import { render, staticRenderFns } from "./UpDownCustomerPdf.vue?vue&type=template&id=85a84bb0&scoped=true"
import script from "./UpDownCustomerPdf.vue?vue&type=script&lang=js"
export * from "./UpDownCustomerPdf.vue?vue&type=script&lang=js"
import style0 from "./UpDownCustomerPdf.vue?vue&type=style&index=0&id=85a84bb0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a84bb0",
  null
  
)

export default component.exports